import React, { useState } from "react";
import { Card, Button, Typography, Tag, Space, Divider, Spin } from "antd";
import { useCrud } from "../hooks/useCrud";

const { Title, Text } = Typography;

const CARD_WIDTH = 384;
const CARD_HEIGHT = 560;
const PRIMARY_COLOR = "#673de6";

/* ---------------- STATIC PLANS (KEEP AS IS) ---------------- */
const STATIC_PLANS = [
  {
    title: "KVM 1",
    price: "$4.99",
    off: "64% OFF",
    renew: "Renews at $ 9.99/mo for 2 years. Cancel anytime.",
    popular: false,
    features: [
      "1 vCPU core",
      "4 GB RAM",
      "50 GB NVMe storage",
      "4 TB bandwidth",
    ],
  },
  {
    title: "KVM 2",
    price: "$5.99",
    off: "67% OFF",
    renew: "Renews at $ 12.99/mo for 2 years. Cancel anytime.",
    popular: true,
    features: [
      "2 vCPU cores",
      "8 GB RAM",
      "100 GB NVMe storage",
      "8 TB bandwidth",
    ],
  },
  {
    title: "KVM 4",
    price: "$9.99",
    off: "67% OFF",
    renew: "Renews at $ 24.99/mo for 2 years. Cancel anytime.",
    popular: false,
    features: [
      "4 vCPU cores",
      "16 GB RAM",
      "200 GB NVMe storage",
      "16 TB bandwidth",
    ],
  },
  {
    title: "KVM 8",
    price: "$19.99",
    off: "67% OFF",
    renew: "Renews at $ 49.99/mo for 2 years. Cancel anytime.",
    popular: false,
    features: [
      "8 vCPU cores",
      "32 GB RAM",
      "400 GB NVMe storage",
      "32 TB bandwidth",
    ],
  },
];

const Pricing = () => {
  const [selected, setSelected] = useState("KVM 2");

  const { useGetAll } = useCrud({
    endpoint: "v1/products/",
    queryKey: "vpsPlans",
  });

  const { data: vpsPlans, isLoading, isError } = useGetAll();


  console.log("FULL API RESPONSE:", vpsPlans);
  console.log("API ARRAY:", vpsPlans?.data);

  /* ---------------- CARD UI ---------------- */
  const renderCard = (plan, key, isApi = false) => {
    const isSelected = selected === plan.title;

    return (
      <Card
        key={key}
        hoverable
        styles={{
          body: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
          },
        }}
        style={{
          width: CARD_WIDTH,
          height: CARD_HEIGHT,
          borderRadius: 14,
          border: isSelected
            ? `2px solid ${PRIMARY_COLOR}`
            : "1px solid #e5e7eb",
          boxShadow: isSelected ? "0 20px 40px rgba(103,61,230,0.25)" : "none",
        }}
      >
        {plan.popular && (
          <Tag
            color="purple"
            style={{
              position: "absolute",
              top: -14,
              left: "50%",
              transform: "translateX(-50%)",
              fontWeight: 600,
            }}
          >
            MOST POPULAR
          </Tag>
        )}

        <Space direction="vertical" size={6}>
          <Title level={4}>{plan.title}</Title>

          {plan.off && <Tag color="blue">{plan.off}</Tag>}

          <Title level={2} style={{ color: PRIMARY_COLOR, margin: 0 }}>
            {plan.price}
            <Text type="secondary"> /mo</Text>
          </Title>

          <Button
            size="large"
            block
            style={{
              marginTop: 16,
              backgroundColor: isSelected ? PRIMARY_COLOR : "#fff",
              borderColor: PRIMARY_COLOR,
              color: isSelected ? "#fff" : PRIMARY_COLOR,
            }}
            onClick={() => setSelected(plan.title)}
          >
            {isSelected ? "Selected" : "Choose plan"}
          </Button>

          {plan.renew && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              {plan.renew}
            </Text>
          )}
        </Space>

        <Divider />

        <Space direction="vertical" size={8}>
          {plan.features?.map((f, i) => (
            <Text key={i}>✔ {f}</Text>
          ))}
        </Space>
      </Card>
    );
  };

  return (
    <div style={{ padding: "80px 24px", background: "#fff" }}>
      <Space direction="vertical" align="center" style={{ width: "100%" }}>
        <Title level={2}>Choose your VPS hosting plan</Title>
      </Space>

      {/* -------- STATIC CARDS -------- */}
      <div style={{ marginTop: 48, display: "flex", justifyContent: "center" }}>
        <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
          {STATIC_PLANS.map((plan, index) =>
            renderCard(plan, `static-${index}`)
          )}
        </div>
      </div>

      {/* -------- API PLANS -------- */}
      <Title level={3} style={{ textAlign: "center", marginTop: 80 }}>
        More VPS Plans
      </Title>

      {isLoading && (
        <div style={{ textAlign: "center", marginTop: 40 }}>
          <Spin size="large" />
        </div>
      )}

      {!isLoading && !isError && (
        <div
          style={{ marginTop: 32, display: "flex", justifyContent: "center" }}
        >
          <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
            {vpsPlans?.data?.map((item, index) =>
              renderCard(
                {
                  title: item.priceItem?.name || "VPS Plan",
                  price: `$${item.priceItem?.price?.[0]?.amount ?? "-"}`,
                  features: item.priceItem.specs.map(

                    (spec) => spec.title
                  )
                },
                item.priceItem?.key || index,
                true
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Pricing;
